import { connect } from 'react-redux';
import LDailyPills from '../Components/LDailyPills';
import { getWeeklyDb, getMonthDb, getDailyDb } from '../Actions/finTrans_actions';
 
 
   
   
const mapStateToProps = ({Fs, Week, Month, Daily}) => {
  let year = Number( new Date().toDateString().substring(10,15).trim() )  
  let month = new Date().toDateString().substring(4,7).trim() 
  let dayNo = Number( new Date().toDateString().substring(7,10).trim() )
   let currYear = Week.filter(s => s.year === year)

  let currMth = currYear.filter(s => s.month === month)
 
  let desiredArr = currMth.filter(s => s.dayNo === dayNo).length >= 1 ? currMth.filter(s => s.dayNo === dayNo) : Daily

  return {
  moneyLeft: Fs.sort((a, b) => b._id - a._id),
  weekly: Week.sort((a, b) => b._id - a._id),
  daily: desiredArr.sort((a, b) => b._id - a._id),
  Monthly: Month.sort((a, b) => b._id - a._id)
}}

const mapDispatchToProps = dispatch => {
  return {
    getWeekly: () => dispatch(getWeeklyDb()),
    getMonthly: () => dispatch(getMonthDb()),
    getDaily: () => dispatch(getDailyDb())
  }
}
 
export default connect(mapStateToProps, mapDispatchToProps)(LDailyPills);